import { render, staticRenderFns } from "./CorrigendumPreviewModal.vue?vue&type=template&id=3dad5446"
import script from "./CorrigendumPreviewModal.vue?vue&type=script&lang=js"
export * from "./CorrigendumPreviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports